/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./Post.css";
import Default from "../../images/default.png";

export default function Post() {
  return (
    <div>
      {/* start */}
      <div className="card">
        <div className="card-body">
          <div className="media">
            <a href="">
              <img className="userPostImg" src={Default} alt="" />
            </a>
            <div className="media-body">
              <div className="d-flex flex-direction-row justify-content-between">
                <a href="/post" className="postTitle mt-0">
                  Title
                </a>
                <div className="postInfos1">
                  <button className="btn btn-sm light" disabled>
                    <i className="fas fa-comment text-secondary"></i> 4
                  </button>
                  &nbsp;
                  <button className="btn btn-sm light" disabled>
                    <i className="fas fa-thumbs-up text-primary"></i> 2
                  </button>
                </div>
              </div>
              <p className="postText">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Voluptatum, doloribus error. Recusandae maxime fugiat est
                doloribus quis voluptatum aperiam excepturi?
              </p>
            </div>
            <div className="d-flex flex-direction-row justify-content-between">
              <p>
                <small>
                  <span className="badge badge-pill bg-warning">Category</span>
                </small>
              </p>
              <p>
                <small className="text-smallDate">March 2 2021</small>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* end */}

      <div className="card">
        <div className="card-body">
          <div className="media">
            <a href="">
              <img className="userPostImg" src={Default} alt="" />
            </a>
            <div className="media-body">
              <div className="d-flex flex-direction-row justify-content-between">
                <a href="/post" className="postTitle mt-0">
                  Title
                </a>
                <div className="postInfos1">
                  <button className="btn btn-sm light" disabled>
                    <i className="fas fa-comment text-secondary"></i> 4
                  </button>
                  &nbsp;
                  <button className="btn btn-sm light" disabled>
                    <i className="fas fa-thumbs-up text-primary"></i> 2
                  </button>
                </div>
              </div>
              <p className="postText">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Voluptatum, doloribus error. Recusandae maxime fugiat est
                doloribus quis voluptatum aperiam excepturi?
              </p>
            </div>
            <div className="d-flex flex-direction-row justify-content-between">
              <p>
                <small>
                  <span className="badge badge-pill bg-warning">Category</span>
                </small>
              </p>
              <p>
                <small className="text-smallDate">March 2 2021</small>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="media">
            <a href="">
              <img className="userPostImg" src={Default} alt="" />
            </a>
            <div className="media-body">
              <div className="d-flex flex-direction-row justify-content-between">
                <a href="/post" className="postTitle mt-0">
                  Title
                </a>
                <div className="postInfos1">
                  <button className="btn btn-sm light" disabled>
                    <i className="fas fa-comment text-secondary"></i> 4
                  </button>
                  &nbsp;
                  <button className="btn btn-sm light" disabled>
                    <i className="fas fa-thumbs-up text-primary"></i> 2
                  </button>
                </div>
              </div>
              <p className="postText">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Voluptatum, doloribus error. Recusandae maxime fugiat est
                doloribus quis voluptatum aperiam excepturi?
              </p>
            </div>
            <div className="d-flex flex-direction-row justify-content-between">
              <p>
                <small>
                  <span className="badge badge-pill bg-warning">Category</span>
                </small>
              </p>
              <p>
                <small className="text-smallDate">March 2 2021</small>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="media">
            <a href="">
              <img className="userPostImg" src={Default} alt="" />
            </a>
            <div className="media-body">
              <div className="d-flex flex-direction-row justify-content-between">
                <a href="/post" className="postTitle mt-0">
                  Title
                </a>
                <div className="postInfos1">
                  <button className="btn btn-sm light" disabled>
                    <i className="fas fa-comment text-secondary"></i> 4
                  </button>
                  &nbsp;
                  <button className="btn btn-sm light" disabled>
                    <i className="fas fa-thumbs-up text-primary"></i> 2
                  </button>
                </div>
              </div>
              <p className="postText">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Voluptatum, doloribus error. Recusandae maxime fugiat est
                doloribus quis voluptatum aperiam excepturi?
              </p>
            </div>
            <div className="d-flex flex-direction-row justify-content-between">
              <p>
                <small>
                  <span className="badge badge-pill bg-warning">Category</span>
                </small>
              </p>
              <p>
                <small className="text-smallDate">March 2 2021</small>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="media">
            <a href="">
              <img className="userPostImg" src={Default} alt="" />
            </a>
            <div className="media-body">
              <div className="d-flex flex-direction-row justify-content-between">
                <a href="/post" className="postTitle mt-0">
                  Title
                </a>
                <div className="postInfos1">
                  <button className="btn btn-sm light" disabled>
                    <i className="fas fa-comment text-secondary"></i> 4
                  </button>
                  &nbsp;
                  <button className="btn btn-sm light" disabled>
                    <i className="fas fa-thumbs-up text-primary"></i> 2
                  </button>
                </div>
              </div>
              <p className="postText">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                Voluptatum, doloribus error. Recusandae maxime fugiat est
                doloribus quis voluptatum aperiam excepturi?
              </p>
            </div>
            <div className="d-flex flex-direction-row justify-content-between">
              <p>
                <small>
                  <span className="badge badge-pill bg-warning">Category</span>
                </small>
              </p>
              <p>
                <small className="text-smallDate">March 2 2021</small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
